"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
//# sourceMappingURL=emote-representation-definition.js.map